import React, { Component } from 'react';
import{
    Col,
    Row, 
    Nav, 
    NavItem, 
    NavLink, 
    TabContent, 
    TabPane,
    Button,
    Table,
    Dropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    Input
} from 'reactstrap';
import classnames from 'classnames';

/**
 * Used for the Listino Prezzi section. 
 */
export class ClientiTabs extends Component {

    constructor(props) {
        super(props);

        this.toggle = this.toggle.bind(this);    
        this.toggleDropdown = this.toggleDropdown.bind(this);

        this.state = {    
            activeTab: '1',
            dropdownOpen: false,
            dropdownVisible: true,
            sedeLegaleVisible: false,
            luogoDiConsegnaVisible: false,
            luogoDiConsegnaSelected: 0,
            luogoDiConsegnaLength: this.props.luogoDiConsegna.length,
            addingLuogoDiConsegna: false,
            pagamentoHeight: "auto",
        };
    
    }

    
    /**
     * Runs upon initial mount of the /listinoPrezzi path
     */
    componentDidMount(){
        
    }

    componentDidUpdate(prevProps, prevState){
        if(prevProps.luogoDiConsegna.length > prevState.luogoDiConsegnaLength && this.state.addingLuogoDiConsegna){
            this.setState({
                luogoDiConsegnaSelected: prevProps.luogoDiConsegna.length-1,
                luogoDiConsegnaLength: prevProps.luogoDiConsegna.length
            })
        }
        else if(prevProps.luogoDiConsegna.length > prevState.luogoDiConsegnaLength){
            this.setState({
                luogoDiConsegnaLength: prevProps.luogoDiConsegna.length
            })
        }
    }

    handleSubmit = (e) => {
        e.preventDefault();
    }

    onDocumentLoadSuccess = ({ numPages }) => {
        this.setState({ numPages });
    }

    toggle(tab) {
        if (this.state.activeTab !== tab) {
            this.setState({
                activeTab: tab,
            });
        }
    }

    toggleDropdown(){
        this.setState({
            dropdownOpen: !this.state.dropdownOpen,
            pagamentoHeight: this.state.pagamentoHeight === "auto" ? "50vh" : "auto"
        })
    }

    getPdf = (e, id) => {
        e.preventDefault();

        fetch(`../api/clienti/fatture/${id}`, {   
            method: 'Get',
            headers: new Headers({
                //Authorization token
                'Authorization': 'Bearer ' + sessionStorage.getItem("auth"),
            }),
            //Changes the response to an object
        }).then(response => response.blob())
        .then(blob => {
            window.open(URL.createObjectURL(blob))
        }).catch(e => {
            console.log(e);
        });

    }

    dropdownOnSelect = (index) => {          
        this.setState({
            luogoDiConsegnaSelected: index
        })
    }

    handleAdd = (e) => {
        this.props.handleLuogoDiConsegnaAddNew(e);

        this.setState({
            addingLuogoDiConsegna: true
        })
    }

    handleDelete = (index) => {
        if(this.state.luogoDiConsegnaSelected > 0){
            this.setState({
                luogoDiConsegnaSelected: this.state.luogoDiConsegnaSelected-1,
            }, this.props.handleLuogoDiConsegnaDelete(index))
        }
        else{
            this.props.handleLuogoDiConsegnaDelete(index)
        }

        this.setState({
            luogoDiConsegnaLength: this.props.luogoDiConsegna.length
        })

    }

    /**
     * Renders the page
     */
    render() {
        
        
        const sedeLegaleTable = () => {
            return (
                <Table responsive borderless key={'sedeLegaleTable'} style={{margin: "0", marginTop: "5px"}}>
                    <tbody style={{fontSize: "20px"}}>
                        <tr>
                            <th style={{width: "25%", padding: "0"}}>Indirizzo 1:  </th>
                            <td align="left" style={{padding: "0"}}>
                                {!this.props.editting
                                    ? (this.props.sedeLegale.indirizzo1 == null ? "" : this.props.sedeLegale.indirizzo1)
                                    : (<Input type="text" name="indirizzo1" id="indirizzo1" style={{fontSize: "20px", height: "25px", padding: "0", paddingLeft: "5px"}} onChange={this.props.handleSedeLegaleChange} value={this.props.sedeLegale.indirizzo1}/>)}
                            </td>
                        </tr>
                        <tr>
                            <th style={{width: "25%", padding: "0"}}>Indirizzo 2:  </th>
                            <td align="left" style={{padding: "0"}}>
                                {!this.props.editting
                                    ? (this.props.sedeLegale.indirizzo2 == null ? "" : this.props.sedeLegale.indirizzo2)
                                    : (<Input type="text" name="indirizzo2" id="indirizzo2" style={{fontSize: "20px", height: "25px", padding: "0", paddingLeft: "5px"}} onChange={this.props.handleSedeLegaleChange} value={this.props.sedeLegale.indirizzo2}/>)}
                            </td>
                        </tr>
                        <tr>
                            <th style={{width: "25%", padding: "0"}}>Localit&#224;:  </th>
                            <td align="left" style={{padding: "0"}}>
                                {!this.props.editting
                                    ? (this.props.sedeLegale.localita == null ? "" : this.props.sedeLegale.localita)
                                    : (<Input type="text" name="localita" id="localita" style={{fontSize: "20px", height: "25px", padding: "0", paddingLeft: "5px"}} onChange={this.props.handleSedeLegaleChange} value={this.props.sedeLegale.localita}/>)}
                            </td>
                        </tr>
                        <tr>
                            <th style={{width: "25%", padding: "0"}}>Citt&#224;:  </th>
                            <td align="left" style={{padding: "0"}}>
                                {!this.props.editting
                                    ? (this.props.sedeLegale.citta == null ? "" : this.props.sedeLegale.citta)
                                    : (<Input type="text" name="citta" id="citta" style={{fontSize: "20px", height: "25px", padding: "0", paddingLeft: "5px"}} onChange={this.props.handleSedeLegaleChange} value={this.props.sedeLegale.citta}/>)}
                            </td>
                        </tr>
                        <tr>
                            <th style={{width: "25%", padding: "0"}}>CAP:  </th>
                            <td align="left" style={{padding: "0"}}>
                                {!this.props.editting
                                    ? (this.props.sedeLegale.cap == null ? "" : this.props.sedeLegale.cap)
                                    : (<Input type="text" name="cap" id="cap" style={{fontSize: "20px", height: "25px", padding: "0", paddingLeft: "5px"}} onChange={this.props.handleSedeLegaleChange} value={this.props.sedeLegale.cap}/>)}
                            </td>
                        </tr>
                        <tr>
                            <th style={{width: "25%", padding: "0"}}>Provincia:  </th>
                            <td align="left" style={{padding: "0"}}>
                                {!this.props.editting
                                    ? (this.props.sedeLegale.provincia == null ? "" : this.props.sedeLegale.provincia)
                                    : (<Input type="text" name="provincia" id="provincia" style={{fontSize: "20px", height: "25px", padding: "0", paddingLeft: "5px"}} onChange={this.props.handleSedeLegaleChange} value={this.props.sedeLegale.provincia}/>)}
                            </td>
                        </tr>
                        <tr>
                            <th style={{width: "25%", padding: "0"}}>Note Contatti:  </th>
                            <td align="left" style={{padding: "0"}}>
                                {!this.props.editting
                                    ? (this.props.sedeLegale.contattiNote == null ? "" : this.props.sedeLegale.contattiNote)
                                    : (<Input type="text" name="contattiNote" id="contattiNote" style={{fontSize: "20px", height: "25px", padding: "0", paddingLeft: "5px"}} onChange={this.props.handleSedeLegaleChange} value={this.props.sedeLegale.contattiNote}/>)}
                            </td>
                        </tr>
                    </tbody>
                </Table>
            )
        }

        const luogoDiConsegnaTable = (index) => {
            return (
                <div>
                    {this.props.luogoDiConsegna.length === 0 
                        ? 
                            [
                                !this.props.editting 
                                    ? sedeLegaleTable() 
                                    : null
                            ]
                        : [
                            (this.props.luogoDiConsegna.length > 1 
                            ? <Dropdown key={'luogoDiConsegnaDropdown'} style={{width: '100%', textAlign: 'center', marginTop: "5px"}} isOpen={this.state.dropdownOpen} toggle={this.toggleDropdown}>
                                <DropdownToggle style={{fontSize: "20px"}} caret>
                                    Seleziona un Luogo Di Consegna
                                </DropdownToggle>
                                <DropdownMenu
                                    modifiers={{
                                        setMaxHeight: {
                                            enabled: true,
                                            order: 890,
                                            fn: (data) => {
                                            return {
                                                ...data,
                                                styles: {
                                                ...data.styles,
                                                overflow: 'auto',
                                                maxHeight: "50vh",
                                                },
                                            };
                                            },
                                        },
                                        computeStyle: {
                                            gpuAcceleration: false
                                        }
                                    }}> 
                                        {this.props.luogoDiConsegna.map((indirizzo, index) => {
                                            return (
                                                <DropdownItem key={index} id={index} onClick={() => this.dropdownOnSelect(index)} style={{fontSize: "20px", color: "#011e41"}}>
                                                    {`${index + 1} - ${indirizzo.citta}, ${indirizzo.provincia} ${indirizzo.cap}`}
                                                </DropdownItem>
                                            )
                                        })}
                                </DropdownMenu>
                            </Dropdown>
                            : null),      
                            <Table responsive borderless key={'luogoDiConsegnaBody'} style={{margin: "0", marginTop: "5px"}}>
                                <tbody style={{fontSize: "20px"}}>
                                    <tr>
                                        <th style={{width: "25%", padding: "0"}}>Indirizzo 1:  </th>
                                        <td align="left" style={{padding: "0"}}>
                                            {!this.props.editting
                                                ? (this.props.luogoDiConsegna[index].indirizzo1 == null ? "" : this.props.luogoDiConsegna[index].indirizzo1)
                                                : (<Input type="text" name="indirizzo1" id="indirizzo1" style={{fontSize: "20px", height: "25px", padding: "0", paddingLeft: "5px"}} onChange={(e) => this.props.handleLuogoDiConsegnaChange(e, index)} value={this.props.luogoDiConsegna[index].indirizzo1}/>)}
                                        </td>
                                    </tr>
                                    <tr>
                                        <th style={{width: "25%", padding: "0"}}>Indirizzo 2:  </th>
                                        <td align="left" style={{padding: "0"}}>
                                            {!this.props.editting
                                                ? (this.props.luogoDiConsegna[index].indirizzo2 == null ? "" : this.props.luogoDiConsegna[index].indirizzo2)
                                                : (<Input type="text" name="indirizzo2" id="indirizzo2" style={{fontSize: "20px", height: "25px", padding: "0", paddingLeft: "5px"}} onChange={(e) => this.props.handleLuogoDiConsegnaChange(e, index)} value={this.props.luogoDiConsegna[index].indirizzo2}/>)}
                                        </td>
                                    </tr>
                                    <tr>
                                        <th style={{width: "25%", padding: "0"}}>Localit&#224;:  </th>
                                        <td align="left" style={{padding: "0"}}>
                                            {!this.props.editting
                                                ? (this.props.luogoDiConsegna[index].localita == null ? "" : this.props.luogoDiConsegna[index].localita)
                                                : (<Input type="text" name="localita" id="localita" style={{fontSize: "20px", height: "25px", padding: "0", paddingLeft: "5px"}} onChange={(e) => this.props.handleLuogoDiConsegnaChange(e, index)} value={this.props.luogoDiConsegna[index].localita}/>)}
                                        </td>
                                    </tr>
                                    <tr>
                                        <th style={{width: "25%", padding: "0"}}>Citt&#224;:  </th>
                                        <td align="left" style={{padding: "0"}}>
                                            {!this.props.editting
                                                ? (this.props.luogoDiConsegna[index].citta == null ? "" : this.props.luogoDiConsegna[index].citta)
                                                : (<Input type="text" name="citta" id="citta" style={{fontSize: "20px", height: "25px", padding: "0", paddingLeft: "5px"}} onChange={(e) => this.props.handleLuogoDiConsegnaChange(e, index)} value={this.props.luogoDiConsegna[index].citta}/>)}
                                        </td>
                                    </tr>
                                    <tr>
                                        <th style={{width: "25%", padding: "0"}}>CAP:  </th>
                                        <td align="left" style={{padding: "0"}}>
                                            {!this.props.editting
                                                ? (this.props.luogoDiConsegna[index].cap == null ? "" : this.props.luogoDiConsegna[index].cap)
                                                : (<Input type="text" name="cap" id="cap" style={{fontSize: "20px", height: "25px", padding: "0", paddingLeft: "5px"}} onChange={(e) => this.props.handleLuogoDiConsegnaChange(e, index)} value={this.props.luogoDiConsegna[index].cap}/>)}
                                        </td>
                                    </tr>
                                    <tr>
                                        <th style={{width: "25%", padding: "0"}}>Provincia:  </th>
                                        <td align="left" style={{padding: "0"}}>
                                            {!this.props.editting
                                                ? (this.props.luogoDiConsegna[index].provincia == null ? "" : this.props.luogoDiConsegna[index].provincia)
                                                : (<Input type="text" name="provincia" id="provincia" style={{fontSize: "20px", height: "25px", padding: "0", paddingLeft: "5px"}} onChange={(e) => this.props.handleLuogoDiConsegnaChange(e, index)} value={this.props.luogoDiConsegna[index].provincia}/>)}
                                        </td>
                                    </tr>
                                    <tr>
                                        <th style={{width: "25%", padding: "0"}}>Note Contatti:  </th>
                                        <td align="left" style={{padding: "0"}}>
                                            {!this.props.editting
                                                ? (this.props.luogoDiConsegna[index].contattiNote == null ? "" : this.props.luogoDiConsegna[index].contattiNote)
                                                : (<Input type="text" name="contattiNote" id="contattiNote" style={{fontSize: "20px", height: "25px", padding: "0", paddingLeft: "5px"}} onChange={(e) => this.props.handleLuogoDiConsegnaChange(e, index)} value={this.props.luogoDiConsegna[index].contattiNote}/>)}
                                        </td>
                                    </tr>
                                </tbody>
                            </Table>
                        ]
                    }
                    <Row className="d-flex justify-content-center align-items-center" style={{marginTop: "5px"}}>
                        
                        {this.props.editting 
                            ? [(this.props.luogoDiConsegna.length > 0 ?
                                <Col className="col-6 d-flex justify-content-center align-items-center" key={"Delete"}>
                                    <Button className="text-center" style={{width: '100%', padding: '0px', backgroundColor: "#011e41", fontSize: "20px"}} onClick={() => this.handleDelete(index)}>
                                        elimina indirizzo
                                    </Button>
                                </Col> : null),
                                <Col className="col-6 d-flex justify-content-center align-items-center" key={"Add"}>
                                    <Button className="text-center" style={{width: '100%', padding: '0px', backgroundColor: "#011e41", fontSize: "20px"}} onClick={this.handleAdd}>
                                        aggiungi un nuovo indirizzo
                                    </Button> 
                                </Col>]
                            : null
                        }   
                    </Row>                    
                </div>
            )
        }
        return (
            <div style={{width: "100%"}}>
                <Nav tabs>
                    <NavItem>
                        <NavLink className={classnames({ active: this.state.activeTab === '1' })} onClick={() => { this.toggle('1'); }} style={{color: "#011e41"}}>
                            Informazione
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink className={classnames({ active: this.state.activeTab === '2' })} onClick={() => { this.toggle('2'); }} style={{color: "#011e41"}}>
                            Sede Legale
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink className={classnames({ active: this.state.activeTab === '3' })} onClick={() => { this.toggle('3'); }} style={{color: "#011e41"}}>
                            Luogo di Consegna
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink className={classnames({ active: this.state.activeTab === '4' })} onClick={() => { this.toggle('4'); }} style={{color: "#011e41"}}>
                            Modalit&#224; di Pagamento
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink className={classnames({ active: this.state.activeTab === '5' })} onClick={() => { this.toggle('5'); }} style={{ color: "#011e41" }}>
                            Fatture
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink className={classnames({ active: this.state.activeTab === '6' })} onClick={() => { this.toggle('6'); }} style={{ color: "#011e41" }}>
                            Estratto Conto
                        </NavLink>
                    </NavItem>
                </Nav>
                    <TabContent activeTab={this.state.activeTab}>                               
                        <TabPane tabId="1">
                            <Row>
                                <Col sm="12">
                                    <Table responsive borderless style={{margin: "0", marginTop: "5px"}}>
                                        <tbody style={{fontSize: "20px"}}>
                                            {(!this.props.isNew || sessionStorage.getItem("selectedRole") === "Amministrazione") ?
                                                <tr>
                                                    <th style={{width: "25%", padding: "0"}}>Codice Cliente:  </th>
                                                    <td align="left" style={{padding: "0"}}>
                                                        {!this.props.editting
                                                            ? (this.props.cliente.codiceCliente == null ? "" : this.props.cliente.codiceCliente)
                                                            : (
                                                            <div>
                                                                {!this.props.isNew
                                                                    ? <Input type="text" name="codiceCliente" id="codiceCliente" style={{fontSize: "20px", height: "25px", padding: "0", paddingLeft: "5px"}} onChange={this.props.handleClienteChange} value={this.props.cliente.codiceCliente}/>
                                                                    : null
                                                                }
                                                            </div>)}
                                                    </td>
                                                </tr>
                                                : null
                                            }
                                            
                                            <tr>
                                                <th style={{width: "25%", padding: "0"}}>Ragione Sociale:  </th>
                                                <td align="left" style={{padding: "0"}}>
                                                    {!this.props.editting
                                                        ? (this.props.cliente.ragSoc == null ? "" : this.props.cliente.ragSoc)
                                                        : (<Input type="text" name="ragSoc" id="ragSoc" style={{fontSize: "20px", height: "25px", padding: "0", paddingLeft: "5px"}} onChange={this.props.handleClienteChange} value={this.props.cliente.ragSoc}/>)}
                                                </td>
                                            </tr>
                                            <tr>
                                                <th style={{width: "25%", padding: "0"}}>Insegna Esterna:  </th>
                                                <td align="left" style={{padding: "0"}}>
                                                    {!this.props.editting
                                                        ? (this.props.cliente.insegnaEsterna == null ? "" : this.props.cliente.insegnaEsterna)
                                                        : (<Input type="text" name="insegnaEsterna" id="insegnaEsterna" style={{fontSize: "20px", height: "25px", padding: "0", paddingLeft: "5px"}} onChange={this.props.handleClienteChange} value={this.props.cliente.insegnaEsterna}/>)}
                                                </td>
                                            </tr>
                                            <tr>
                                                <th style={{width: "25%", padding: "0"}}>Partita IVA:  </th>
                                                <td align="left" style={{padding: "0"}}>
                                                    {!this.props.editting
                                                        ? (this.props.cliente.piva == null ? "" : this.props.cliente.piva)
                                                        : (<Input type="text" name="piva" id="piva" style={{fontSize: "20px", height: "25px", padding: "0", paddingLeft: "5px"}} onChange={this.props.handleClienteChange} value={this.props.cliente.piva}/>)}
                                                </td>
                                            </tr>
                                            <tr>
                                                <th style={{width: "25%", padding: "0"}}>Codice Fiscale:  </th>
                                                <td align="left" style={{padding: "0"}}>
                                                    {!this.props.editting
                                                        ? (this.props.cliente.codFisc == null ? "" : this.props.cliente.codFisc)
                                                        : (<Input type="text" name="codFisc" id="codFisc" style={{fontSize: "20px", height: "25px", padding: "0", paddingLeft: "5px"}} onChange={this.props.handleClienteChange} value={this.props.cliente.codFisc}/>)}
                                                </td>
                                            </tr>
                                            <tr>
                                                <th style={{width: "25%", padding: "0"}}>SDI:  </th>
                                                <td align="left" style={{padding: "0"}}>
                                                    {!this.props.editting
                                                        ? (this.props.cliente.sdi == null ? "" : this.props.cliente.sdi)
                                                        : (<Input type="text" name="sdi" id="sdi" style={{fontSize: "20px", height: "25px", padding: "0", paddingLeft: "5px"}} onChange={this.props.handleClienteChange} value={this.props.cliente.sdi}/>)}
                                                </td>
                                            </tr>
                                            <tr>
                                                <th style={{ width: "25%", padding: "0" }}>Telefono:  </th>
                                                <td align="left" style={{ padding: "0" }}>
                                                    {!this.props.editting
                                                    ? (this.props.cliente.telefono == null ? "" : this.props.cliente.telefono)
                                                    : (<Input type="text" name="telefono" id="telefono" style={{ fontSize: "20px", height: "25px", padding: "0", paddingLeft: "5px" }} onChange={this.props.handleClienteChange} value={this.props.cliente.telefono} />)}
                                                </td>
                                            </tr>
                                            <tr>
                                                <th style={{ width: "25%", padding: "0" }}>Cellulare:  </th>
                                                <td align="left" style={{ padding: "0" }}>
                                                    {!this.props.editting
                                                    ? (this.props.cliente.cellulare == null ? "" : this.props.cliente.cellulare)
                                                    : (<Input type="text" name="cellulare" id="cellulare" style={{ fontSize: "20px", height: "25px", padding: "0", paddingLeft: "5px" }} onChange={this.props.handleClienteChange} value={this.props.cliente.cellulare} />)}
                                                </td>
                                            </tr>
                                            <tr>
                                                <th style={{ width: "25%", padding: "0" }}>Fax:  </th>
                                                <td align="left" style={{ padding: "0" }}>
                                                    {!this.props.editting
                                                    ? (this.props.cliente.fax == null ? "" : this.props.cliente.fax)
                                                    : (<Input type="text" name="fax" id="fax" style={{ fontSize: "20px", height: "25px", padding: "0", paddingLeft: "5px" }} onChange={this.props.handleClienteChange} value={this.props.cliente.fax} />)}
                                                </td>
                                            </tr>
                                            <tr>
                                                <th style={{width: "25%", padding: "0"}}>Email:  </th>
                                                <td align="left" style={{padding: "0"}}>
                                                    {!this.props.editting
                                                        ? (this.props.cliente.email == null ? "" : this.props.cliente.email)
                                                        : (<Input type="email" name="email" id="email" style={{fontSize: "20px", height: "25px", padding: "0", paddingLeft: "5px"}} onChange={this.props.handleClienteChange} value={this.props.cliente.email}/>)}
                                                </td>
                                            </tr>
                                            <tr>
                                                <th style={{width: "25%", padding: "0"}}>PEC:  </th>
                                                <td align="left" style={{padding: "0"}}>
                                                    {!this.props.editting
                                                        ? (this.props.cliente.pec == null ? "" : this.props.cliente.pec)
                                                        : (<Input type="text" name="pec" id="pec" style={{fontSize: "20px", height: "25px", padding: "0", paddingLeft: "5px"}} onChange={this.props.handleClienteChange} value={this.props.cliente.pec}/>)}
                                                </td>
                                            </tr>
                                            <tr>
                                                <th style={{width: "25%", padding: "0"}}>Persona di Contatto:  </th>
                                                <td align="left" style={{padding: "0"}}>
                                                    {!this.props.editting
                                                        ? (this.props.cliente.contatto == null ? "" : this.props.cliente.contatto)
                                                        : (<Input type="text" name="contatto" id="contatto" style={{fontSize: "20px", height: "25px", padding: "0", paddingLeft: "5px"}} onChange={this.props.handleClienteChange} value={this.props.cliente.contatto}/>)}
                                                </td>
                                            </tr>
                                            <tr>
                                                <th style={{width: "25%", padding: "0"}}>Settore di attività  </th>
                                                <td align="left" style={{padding: "0"}}>
                                                    {!this.props.editting
                                                        ? (this.props.cliente.settore == null ? "" : this.props.cliente.settore)
                                                        : (<Input type="text" name="settore" id="settore" style={{fontSize: "20px", height: "25px", padding: "0", paddingLeft: "5px"}} onChange={this.props.handleClienteChange} value={this.props.cliente.settore}/>)}
                                                </td>
                                            </tr>
                                            <tr>
                                                <th style={{width: "25%", padding: "0"}}>Note:  </th>
                                                <td align="left" style={{padding: "0"}}>
                                                    {(!this.props.editting && sessionStorage.getItem("selectedRole") === "Agenti") || (this.props.isNew && !this.props.isApprove) || (!this.props.editting && !this.props.isApprove)
                                                        ? (this.props.cliente.note == null ? "" : this.props.cliente.note)
                                                        : (<Input type="textarea" name="note" id="note" style={{fontSize: "20px", height: "100%", padding: "0", paddingLeft: "5px", marginBottom: "5px"}} onChange={this.props.handleClienteChange} value={this.props.cliente.note}/>)}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                </Col>
                            </Row>
                        </TabPane>
                        <TabPane tabId="2">
                            <Row>
                                <Col sm="12">
                                    {sedeLegaleTable()}
                                </Col>
                            </Row>
                        </TabPane>
                        <TabPane tabId="3">
                            <Row>
                                <Col sm="12">
                                    {luogoDiConsegnaTable(this.state.luogoDiConsegnaSelected)}
                                </Col>
                            </Row>
                        </TabPane>
                        <TabPane tabId="4">
                            <Row>
                                <Col sm="12" className="d-flex justify-content-startv align-items-center">
                                    <Table responsive borderless style={{margin: "0", marginBottom: "10px", height: this.state.pagamentoHeight}}>
                                        <tbody style={{fontSize: "20px", overflow: "visible"}}>
                                            <tr>
                                                <th style={{width: "25%", padding: "0", overflow: "visible"}}>Descrizione di Pagamento:  </th>
                                                <td align="left" style={{padding: "0", overflow: "visible"}}>
                                                    {!this.props.editting
                                                        ? (this.props.pagamento.descrizione == null ? "" : this.props.pagamento.descrizione)
                                                        : (<div style={{position: "relative"}}>
                                                            <Dropdown style={{height: '25px',textAlign: 'center', marginTop: "5px", float: "left"}} isOpen={this.state.dropdownOpen} toggle={this.toggleDropdown}>
                                                                <DropdownToggle style={{fontSize: "20px", padding: "0", paddingRight: "10px", paddingLeft: "10px"}} caret>
                                                                    {this.props.pagamento.descrizione != null ? this.props.pagamento.descrizione : "seleziona una modalità di pagamento"}
                                                                </DropdownToggle>
                                                                <DropdownMenu
                                                                    modifiers={{
                                                                        setMaxHeight: {
                                                                            enabled: true,
                                                                            order: 890,
                                                                            fn: (data) => {
                                                                            return {
                                                                                ...data,
                                                                                styles: {
                                                                                ...data.styles,
                                                                                overflow: 'auto',
                                                                                maxHeight: "50vh",
                                                                                },
                                                                            };
                                                                            },
                                                                        },
                                                                        computeStyle: {
                                                                            gpuAcceleration: false
                                                                        }
                                                                    }}> 
                                                                        {this.props.pagamentiList.map((pagamento, index) => {
                                                                            return (
                                                                                <DropdownItem key={pagamento.pagamentoId} id={pagamento.pagamentoId} style={{fontSize: "20px", color: "#011e41"}} onClick={() => this.props.handlePagamentoChange(index)}>
                                                                                    {`${pagamento.pagamentoId} - ${pagamento.descrizione}`}
                                                                                </DropdownItem>
                                                                            )
                                                                        })}
                                                                </DropdownMenu>
                                                            </Dropdown>
                                                        </div>)}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                </Col>
                            </Row>
                    </TabPane>
                    <TabPane tabId="5">
                        <Row>
                            <Col sm="12" className="d-flex justify-content-startv align-items-center">
                                <Row style={{ width: "100%" }}>
                                    <Table responsive borderless style={{ margin: "0", fontSize: "20px" }}>
                                        <thead>
                                            <tr style={{ borderBottom: "1px solid #011e41" }}>
                                                <th style={{ padding: "0" }}>Numero Documento</th>
                                                <th style={{ padding: "0" }}>Descrizione</th>
                                                <th style={{ padding: "0" }}>Data Documento</th>
                                                <th style={{ padding: "0" }}>Data Scadenza</th>
                                                <th style={{ padding: "0" }}>Scaduto</th>
                                                <th style={{ padding: "0" }}>Insoluto</th>
                                                <th style={{ padding: "0" }}>A Scadere</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.props.fatture.map(fattura => {
                                                return (
                                                    <tr key={fattura.fatturaId}>
                                                        <td align="left" style={{ padding: "0" }}>{fattura.numDoc}</td>
                                                        <td align="left" style={{ padding: "0" }}>{fattura.descCausale}</td>
                                                        <td align="left" style={{ padding: "0" }}>{new Date(fattura.dataDocumento).toLocaleDateString()}</td>
                                                        <td align="left" style={{ padding: "0" }}>{new Date(fattura.dataScadenza).toLocaleDateString()}</td>
                                                        <td align="left" style={{ padding: "0" }}>{new Intl.NumberFormat('it-It', { style: 'currency', currency: 'EUR' }).format(parseFloat(fattura.totScaduto).toFixed(2))}</td>
                                                        <td align="left" style={{ padding: "0" }}>{new Intl.NumberFormat('it-It', { style: 'currency', currency: 'EUR' }).format(parseFloat(fattura.totInsoluto).toFixed(2))}</td>
                                                        <td align="left" style={{ padding: "0" }}>{new Intl.NumberFormat('it-It', { style: 'currency', currency: 'EUR' }).format(parseFloat(fattura.totAScadere).toFixed(2))}</td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </Table>
                                </Row>
                            </Col>
                        </Row>
                    </TabPane>
                    <TabPane tabId="6">
                        <Row>
                            <Col sm="12" className="d-flex justify-content-startv align-items-center">
                                <Row style={{ width: "100%" }}>
                                    <Table responsive borderless style={{ margin: "0", fontSize: "20px" }}>
                                        <thead>
                                            <tr style={{ borderBottom: "1px solid #011e41" }}>
                                                <th style={{ padding: "0" }}>Tipo Movimento</th>
                                                <th style={{ padding: "0" }}>Dare</th>
                                                <th style={{ padding: "0" }}>Avere</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.props.econto.map(ec => {
                                                return (
                                                    <tr key={ec.eCid}>
                                                        <td align="left" style={{ padding: "0" }}>{ec.tipoRec}</td>
                                                        <td align="left" style={{ padding: "0" }}>{new Intl.NumberFormat('it-It', { style: 'currency', currency: 'EUR' }).format(parseFloat(ec.dare).toFixed(2))}</td>
                                                        <td align="left" style={{ padding: "0" }}>{new Intl.NumberFormat('it-It', { style: 'currency', currency: 'EUR' }).format(parseFloat(ec.avere).toFixed(2))}</td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </Table>
                                </Row>
                            </Col>
                        </Row>
                    </TabPane>                    
                    </TabContent>
            </div>
        )
    }
}

/*{this.props.EConto.map(EC => {
                                                return (
                                                    <tr key={EC.ECid}>
                                                        <td align="left" style={{ padding: "0" }}>{EC.ECid}</td>
                                                        <td align="left" style={{ padding: "0" }}>{EC.TipoRec}</td>
                                                        <td align="left" style={{ padding: "0" }}>€ {EC.Dare}</td>
                                                    </tr>
                                                );
                                            })}*/


// WEBPACK FOOTER //
// ./src/components/ClientiTabs.js